import GeoJSONLayer from '@arcgis/core/layers/GeoJSONLayer';
import keys from './keys';
/*
import { shellfishSpeciesMatrix, 
	//shellfishBayData
} from './species/json.js';
*/



const publicDataRenderer = {
	type: 'simple',
	symbol: {
	  type: "simple-marker",
	  style: "circle",
	  color: [127, 127, 127],
	  outline: {
		color: [0, 0, 0, 1],
		width: 1
	  },
	  size: "8px"
	},
	visualVariables: [
		{
			type: "color",
			field: "prev",
			title:'Prevalence',
			legendOptions: {
				title: 'Prevalence'
			},
			stops: [
				{ value: 0, color: "#ffffb2", label: '0' },
				{ value: .25, color: "#fecc5c" },
				{ value: .5, color: "#fd8d3c", label: '.5' },
				{ value: .75, color: "#f03b20" },
				{ value: 1, color: "#bd0026", label: '1' }
			]
			// #ffffb2|#fecc5c|#fd8d3c|#f03b20|#bd0026

		},
		{
			type: "size",
			field: "sample_size",
			legendOptions: {
				title: 'Sample Size'
			},
			
			stops: [
				{
				value: 100,
				size: "8px",
				label: "<100"
			  },
			  {
				value: 500,
				size: "12px",
				label: "101-500"
			  },
			  {
				value: 1000,
				size: "16px",
				label: "501-1000"
			  },
			  {
				value: 2000,
				size: "20px",
				label: "1001-2000"
			  },
			  {
				value: 9999999999999,
				size: "24px",
				label: "> 2000"
			  }
			],
			
			/*
  			stops: [
				{value:100, size: 8}
				,{value:500, size: 13}
				,{value:1000, size: 18}
				,{value:2000, size: 24}
			],
*/
			title:'Sample Size',
			/*
			minDataValue: 100,
			maxDataValue: 2000,
			minSize: 8,
			maxSize: 24
			*/
		}
	]
};
/*



*/
/*
const ageRenderer = {
	type: "unique-value",  // autocasts as new UniqueValueRenderer()
	//This is  *NOT* javascript. Use arcade expressions.
	valueExpression:`
		var myCurrentTime = Date();
		var myEarliestTime = Date( $feature.earliest_date )

		var myYearDiff = DateDiff(myCurrentTime, myEarliestTime, 'years');

		if( myYearDiff >5 ) {
			//More than 5 years Old (6+)
			return 'more-than-five-years-old';
		}
		if( myYearDiff>=3 ) {
			//Between 3 and 5 years old
			return 'three-to-five-years-old';
		}

		return 'newer-than-three-years-old';
	`, //"When($feature.count < 20, 'low', $feature.count >= 20 && $feature.count < 70, 'moderate', $feature.count >=70, 'high', 'other')",
	valueExpressionTitle:'Age (In Years)', 
	defaultSymbol: {
	  type: "simple-marker",
	  style: "circle",
	  color: [127, 127, 127],
	  outline: {
		color: [0, 0, 0, 1],
		width: 1
	  },
	  size: "8px"
	},
	defaultLabel: 'Unknown Age',
	uniqueValueInfos: [ 
		{
			value: "more-than-five-years-old",  // features labeled as "High"
			label: "Older than 5 Years Old",
			symbol: {
			  type: "simple-marker",
			  style: "circle",
			  color: [255, 255, 0],
			  outline: {
				color: [0, 0, 0, 1],
				width: 1
			  },
			  size: "8px"
			}  // will be assigned sym1
		  },{
			value: "three-to-five-years-old",  // features labeled as "High"
			label: "Between 3 to 5 Years Old",
			symbol: {
			  type: "simple-marker",
			  style: "circle",
			  color: [0, 255, 0],
			  outline: {
				color: [0, 0, 0, 1],
				width: 1
			  },
			  size: "8px"
			}  // will be assigned sym1
		  },{
			value: "newer-than-three-years-old",  // features labeled as "High"
			label:'Newer than 3 Years Old',
			symbol: {
			  type: "simple-marker",
			  style: "circle",
			  color: [0, 0, 255],
			  outline: {
				color: [0, 0, 0, 1],
				width: 1
			  },
			  size: "8px"
			}  // will be assigned sym1
		  }
	],  // assigns symbols to features evaluating to 'low', 'moderate', or 'high'
  


};
*/

const createPopupTemplate = (thisGraphic)  => {
	//console.log('Graphic', thisGraphic);
	console.warn('[Pathogen / Species GeoJSON','Not sure why table is outputting two <tbody> elements. May have to return a normal table element?');
						
	const table =document.createElement('table');
	table.classList.add('pathogen-table');

	const tableInformation = JSON.parse( thisGraphic.graphic.attributes.tableInfo );
	const trCollection = [];

	const tbody = document.createElement('tbody');
	const thead = document.createElement('thead');


	Object.keys(tableInformation).forEach( (data_year, _idx) =>{
		const myInfo = tableInformation[data_year];
		
		trCollection.push(`<tr><td>${myInfo.year}</td><td>${myInfo.sample_size.toLocaleString("en-US").toLocaleString("en-US",{maximumFractionDigits: 0})
		}</td><td>${myInfo.prev.toLocaleString("en-US",{maximumFractionDigits: 2})
		}</td><td>${myInfo.advPrev !== null ? myInfo.advPrev.toLocaleString("en-US",{maximumFractionDigits: 2}) : 'N/A'}</td><td>${
			myInfo.wPrev !== null ? myInfo.wPrev.toLocaleString("en-US",{maximumFractionDigits: 2}) : 'N/A'
		}</td></tr>`)
	} );
	thead.innerHTML=`<tr style="background-color:white;border-top:0;">
	<th>Year</th>
	<th>Total</th>
	<th>Prev.</th>
	<th>Adv. Prev.</th>
	<th>Weighted Prev.</th></tr>`;
	tbody.innerHTML = trCollection.reverse().join('');

	table.appendChild(thead);
	table.appendChild(tbody);
	return table;
/*
	
	Object.keys(tableInformation).forEach( (data_year, _idx) =>{
		const myInfo = tableInformation[data_year];
		
		trCollection.push(`<tr><td>${myInfo.year}</td><td>${myInfo.sample_size.toLocaleString("en-US").toLocaleString("en-US",{maximumFractionDigits: 0})
		}</td><td>${myInfo.prev.toLocaleString("en-US",{maximumFractionDigits: 2})
		}</td><td>${myInfo.advPrev.toLocaleString("en-US",{maximumFractionDigits: 2})}</td><td>${myInfo.wPrev.toLocaleString("en-US",{maximumFractionDigits: 2})
		}</td></tr>`)
	} );
	
	return `<table class="pathogen-table">
		<thead><tr style="background-color:white;border-top:0;">
			<th>Year</th>
			<th>Total</th>
			<th>Prev.</th>
			<th>Adv. Prev.</th>
			<th>Weighted Prev.</th></tr>
		</thead>
		<tbody>${[...trCollection].reverse().join('')}</tbody>
	</table>`;
*/
}

const CreateMonitoringDataGeoJsonLayer = (title='', speciesKey=null, pathogenKey=null, seasonKey='all', yearsKey='all') => {

	const speciesName = speciesKey && keys.species[speciesKey] ? keys.species[speciesKey].name : null;
	const pathogenName = pathogenKey && keys.pathogens[pathogenKey] ? keys.pathogens[pathogenKey].name : null;
	
	return new GeoJSONLayer({
		title,
		outFields: ['*'],
		url: `${process.env.REACT_APP_API_URL}/geoJsonData/filter`,
		popupEnabled:true,
		renderer:publicDataRenderer,
		customParameters:{
			dataset: 'musselWatch',
			species: speciesName,
			pathogen: pathogenName ,
			season: seasonKey || undefined,
			years: yearsKey || undefined,
		},
		popupTemplate:{
			title: `{state} - {region} - {subregion}`,
		
			content: [
				{
					type:'text',
					text: 'Data from <b>{earliest_date_format}</b> to <b>{latest_date_format}</b>'
				},
				{
					type: "fields",
					fieldInfos: [
					{
						fieldName: "species",
						label: "Species"
					},
					{
						fieldName: "pathogens",
						label: "Pathogens"
					},
					{
						fieldName: "sample_size",
						label: "Total Individual Samples",
						format: {
							digitSeparator: true, // Uses a comma separator in numbers >999
							places: 0 // Sets the number of decimal places to 0 and rounds up
						}
					},
					{
						fieldName: "prev",
						label: "Prevalence",
						format: {
							digitSeparator: true, // Uses a comma separator in numbers >999
							places: 2 // Sets the number of decimal places to 0 and rounds up
						}
					},
					{
						fieldName: "adv_prev",
						label: "Advanced Prevalence",
						format: {
							digitSeparator: true, // Uses a comma separator in numbers >999
							places: 2 // Sets the number of decimal places to 0 and rounds up
						}
					},
					{
						fieldName: "w_prev",
						label: "Weighted Prevalence",
						format: {
							digitSeparator: true, // Uses a comma separator in numbers >999
							places: 2 // Sets the number of decimal places to 0 and rounds up
						}
					}
					]
				},
				{
					type:'custom',
					creator: createPopupTemplate
				},
			]
		}
	});

}












export const musselWatchLayers = {
	title: 'Mussel Watch Program Data (Historical)', 
	type: 'group', 
	items: [
		{layerId:'historical-psd', type:'layer', item: CreateMonitoringDataGeoJsonLayer('All Mussel Watch Data Points'), meta: null}
	].concat(
		keys.availableCurrentData.map ( (speciesDataInfo) => {
			const speciesKey = speciesDataInfo.speciesKey;
		
			const availableSeasons = [
				{ label: "All Data", key:'all'}, 
				{ label: "January to June Data", key:'jan-to-jun'}, 
				{ label: "July to December Data", key:'jul-to-dec'}
			];
			/*
			const availableYears = [
				{label: "Latest Data", key:'latest'},
				{label: "Data from Past 3 Years", key:'past-three'},
				{label: "Data from Past 5 Years", key:'past-five'}, 
				{label: "All Years", key: 'all'}
			];
		*//*
			const defaultValues = {
				seasons: 'all',
				//years: 'latest'
			}
			*/
			const filters =[
				{filterKey:'seasons', groupLabel: 'Month Range', options: availableSeasons},
				//{filterKey:'years',  groupLabel: 'Timeframe', options: availableYears},
			];
		
			const sublayerItems = []
		
			//for sake of time and just getting this done.
			availableSeasons.forEach( (seasonItem) => {
				//availableYears.forEach( (yearItem) => {
					sublayerItems.push({
						key:`${seasonItem.key}`,
						title: `${seasonItem.label}`,
						season: seasonItem.key,
						//years: yearItem.key
					});
				//})
			})
			
		
		
			const mySpeciesFolder = {
				id: `historical-psd-${speciesKey}`,
				type: 'group',
				items: [ //across all pathogens
					{
						layerId: `historical-psd-${speciesKey}-all`,
						type: 'layer',
						item: CreateMonitoringDataGeoJsonLayer(`Across All Pathogens: ${keys.species[speciesKey].name} (${keys.species[speciesKey].sciName})`, speciesKey),
						containsSublayers: {
							filters,
							values: {
								seasons: 'all',
								//years: 'latest'
							},
							sublayerLayers: sublayerItems.map( (sublayerData) => {
								return {
									key: sublayerData.key,
									//optionTitle: seasonal.optionTitle,
									layerId: `historical-psd-${speciesKey}-${sublayerData.season}-${sublayerData.years}`,
									type: 'layer',
									item: CreateMonitoringDataGeoJsonLayer(
										`Across All Pathogens: ${keys.species[speciesKey].name} (${keys.species[speciesKey].sciName}) [${sublayerData.title}]`, speciesKey, null, sublayerData.season, 
										//sublayerData.years 
									),
									hideInMenu: true,
									meta: null
								};
							})
						}
					}
				].concat( 
					speciesDataInfo.pathogenKeys.map( (pathogenKey) => {
						return {
							layerId: `historical-psd-${speciesKey}-${pathogenKey}-all`,
							type: 'layer',
							item: CreateMonitoringDataGeoJsonLayer(`${keys.pathogens[pathogenKey].name}: ${keys.species[speciesKey].name} (${keys.species[speciesKey].sciName})`
							, speciesKey, pathogenKey),
							containsSublayers: {
								filters,
								values: {
									seasons: 'all',
									//years: 'latest'
								},
								sublayerLayers: sublayerItems.map( (sublayerData) => {
									return {
										key: sublayerData.key,
										//optionTitle: seasonal.optionTitle,
										layerId: `historical-psd-${speciesKey}-${pathogenKey}-${sublayerData.season}-${sublayerData.years}`,
										type: 'layer',
										item: CreateMonitoringDataGeoJsonLayer(
											`${keys.pathogens[pathogenKey].name}: ${keys.species[speciesKey].name} (${keys.species[speciesKey].sciName}) [${sublayerData.title}]`, 
											speciesKey, pathogenKey, sublayerData.season, 
											//sublayerData.years 
										),
										hideInMenu: true,
										meta: null
									};
								})
							}
						}
					})
				),
				title: `${keys.species[speciesKey].name} (${keys.species[speciesKey].sciName})`,
				description: 'Please select a pathogen below'
			}
		
		
		
			return mySpeciesFolder;
		}).filter( (removeNull) => removeNull!==null)
	)
}